import React from 'react';
import FeaturedOffersModule from 'components/FeaturedOffersModule';
import {
  offersAtSelectedDestinationSelector,
  offersSortedByExpireSelector,
} from 'store/offers/offers.selectors';
import {useSelector} from 'Provider';

const ConnectedFeaturedOffersModule = () => {
  const offers = useSelector(offersSortedByExpireSelector);

  const offersAtSelectedDestination = useSelector(
    offersAtSelectedDestinationSelector
  );

  return (
    <FeaturedOffersModule
      featuredOffers={
        offersAtSelectedDestination.length > 0
          ? offersAtSelectedDestination
          : offers
      }
    />
  );
};

export default ConnectedFeaturedOffersModule;
